import styled from "styled-components";
import { WrapContainer } from "./wrapContainer";
import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ProposteRataQuery, useProposteRataQuery } from "../generated/graphql";
import { RoundedButton } from "./roundedButton";
import { Link } from "react-router-dom";
import { CardGrid } from "./carGrid";
const Container = styled.form`
  max-width: var(--page-max-width);
  width: 100%;
  padding-top: 2em;
  padding-bottom: 2em;
  h1 {
    color: white;
  }
`;

const Card = styled.article`
  width: min(450px, 100%);
  box-sizing: border-box;
  padding: 16px;

  text-align: center;
  background-color: white;
`;
const Vat = styled.span`
  opacity: 0.8;
  font-size: 0.8rem;
  font-weight: 400;
  color: black;
`;
const WrapDarkContainer = styled(WrapContainer)`
  background-color: #2e2e2e;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  grid-template-rows: auto auto auto auto; /* title, subtitle, price, footer */
  grid-template-areas:
    "image title"
    "image subtitle"
    "image price"
    "specs availability";
  column-gap: 24px;
  row-gap: 12px;

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "title"
      "subtitle"
      "image"
      "price"
      "specs"
      "availability";
  }
`;

const ImageArea = styled.div`
  grid-area: image;
  align-self: center;
  justify-self: center;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;

  img {
    width: 100%;
    height: 100%;
    max-height: 200px;
    object-fit: contain;
  }
`;

const Title = styled.h1`
  grid-area: title;
  margin: 0;
  color: black !important;
`;

const Subtitle = styled.h2`
  grid-area: subtitle;
  margin: 0;
  font-weight: 400;
  font-size: 1.5rem;
`;

const Price = styled.div`
  grid-area: price;
  align-self: end;
  font-size: 1.8rem;
  font-weight: 800;
  color: #be1522;
`;
const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2em;
`;

const Specs = styled.div`
  grid-area: specs;
  align-self: end;
  opacity: 0.8;
`;

const Availability = styled.div`
  grid-area: availability;

  align-self: end;
  font-size: 0.7rem;
  text-transform: uppercase;
`;

const OfferCard = styled.article`
  width: min(360px, 100%);
  min-height: 500px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  color: rgb(102, 102, 102);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 24px;
  background-color: white;

  h1 {
    margin: 0 0 6px;
    font-size: 1.9rem;
    line-height: 1.1;
  }

  p {
    margin: 0;
  }

  @media screen and (max-width: 550px) {
    width: 280px;
    min-height: 470px;
    padding: 18px 14px;
  }
`;

const OfferImage = styled.img`
  width: 300px;
  height: 200px;
  object-fit: contain;
  object-position: center;
  margin-top: 1em;

  @media screen and (max-width: 550px) {
    width: 250px;
  }
`;

const OfferPrice = styled.div`
  color: #be1522;
  padding-top: 1em;
  padding-bottom: 0.5em;
  font-size: 1.35em;
  font-weight: bold;

  strong {
    font-size: 2.1em;
    line-height: 1;
  }
`;

const OfferSpecs = styled.div`
  margin-bottom: 1em;
`;

const OfferFuel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  line-height: 1;
  margin-bottom: 1em;
  min-height: 30px;

  img {
    width: 30px;
    height: auto;
    max-height: 30px;
    object-fit: contain;
  }
`;

const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 16px 0;
`;

const DotButton = styled.button<{ active: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  padding: 0;
  background-color: ${({ active }) => (active ? "#be1522" : "#d6d6d6")};
  cursor: pointer;
  transition:
    background-color 0.2s ease-in-out,
    transform 0.2s ease-in-out;

  &:hover,
  &:focus {
    background-color: #be1522;
    transform: scale(1.05);
  }
`;

type PropostaRataItem = NonNullable<
  NonNullable<ProposteRataQuery["proposteDiRataCollection"]>["items"][number]
>;

function PropostaRataCard(props: {
  item: PropostaRataItem;
  className?: string;
}) {
  const { item } = props;

  return (
    <Card className={props.className}>
      <Grid>
        <ImageArea>
          <img
            src={
              item?.immagine?.url ||
              "https://dummyimage.com/560x280/cccccc/000000&text=car"
            }
            alt={item?.marca || "Car"}
          />
        </ImageArea>

        <Title>{item?.marca || "Title"}</Title>
        <Subtitle>{item?.modello || "Subtitle"}</Subtitle>

        <Price>
          <Vat>Canone IVA compresa</Vat>
          <br />
          <br />
          {item?.canoneMensile ? `${item.canoneMensile}€/mese` : "N/A"}
        </Price>

        <Specs>{`${item?.mesi} Mesi | ${item?.chilometri} km | ${item?.alimentazione}`}</Specs>
        <Availability>
          Disponibilità: {item?.disponibilit || "N/A"}
        </Availability>
      </Grid>
    </Card>
  );
}

function getTractionIcon(alimentazione?: string | null) {
  const value = alimentazione?.toLowerCase() || "";

  if (value.includes("elettr")) {
    return "/iconsTractions/elettrica.webp";
  }

  if (value.includes("hybrid") || value.includes("ibrid")) {
    return "/iconsTractions/ibrida.webp";
  }

  return "/iconsTractions/termica.webp";
}

function PropostaRataGridCard(props: { item: PropostaRataItem }) {
  const { item } = props;

  return (
    <OfferCard>
      <h1>{item?.marca || "Title"}</h1>
      <p>{item?.modello || "Subtitle"}</p>
      <OfferImage
        src={
          item?.immagine?.url ||
          "https://dummyimage.com/560x280/cccccc/000000&text=car"
        }
        alt={`${item?.marca || "Auto"} ${item?.modello || ""}`.trim()}
      />
      <OfferPrice>
        <strong>{item?.canoneMensile || "N/A"}</strong>
        {item?.canoneMensile ? "€ al mese IVA inclusa" : ""}
      </OfferPrice>
      <OfferSpecs>{`${item?.mesi || "N/A"} mesi | ${
        item?.chilometri || "N/A"
      } km | Anticipo 0€`}</OfferSpecs>
      <OfferFuel>
        <img src={getTractionIcon(item?.alimentazione)} alt="" />
        <span>{item?.alimentazione || "N/A"}</span>
      </OfferFuel>
      <Link to="/preventivo">
        <RoundedButton className="solid">RICHIEDI UN PREVENTIVO</RoundedButton>
      </Link>
    </OfferCard>
  );
}

const CarouselPropostaRataCard = styled(PropostaRataCard)`
  flex: 0 0 350px;
`;

const OffersGridContainer = styled(Container)`
  h1 {
    color: black;
  }
`;

export function ProposteRataGrid(props: { title?: string }) {
  const [proposte] = useProposteRataQuery();
  const items = proposte.data?.proposteDiRataCollection?.items;

  return (
    <WrapContainer grey>
      <OffersGridContainer>
        <h1>{props.title || "LE NOSTRE PROPOSTE DI RATA"}</h1>
        <CardGrid>
          {items?.map((item, index) =>
            item ?
              <PropostaRataGridCard item={item} key={item._id || index} />
            : null,
          )}
        </CardGrid>
      </OffersGridContainer>
    </WrapContainer>
  );
}

export function ProposteRata() {
  const [emblaRef, emblaApi] = useEmblaCarousel();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
  const [proposte] = useProposteRataQuery();
  const items = proposte.data?.proposteDiRataCollection?.items;
  const scrollTo = useCallback(
    (index: number) => emblaApi && emblaApi.scrollTo(index),
    [emblaApi],
  );

  useEffect(() => {
    if (!emblaApi) {
      return;
    }

    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    const onReInit = () => {
      setScrollSnaps(emblaApi.scrollSnapList());
      onSelect();
    };

    setScrollSnaps(emblaApi.scrollSnapList());
    onSelect();

    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onReInit);

    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onReInit);
    };
  }, [emblaApi]);

  return (
    <WrapDarkContainer>
      <Container>
        <h1>LE NOSTRE PROPOSTE DI RATA</h1>
        <div className="embla" ref={emblaRef}>
          <div className="embla__container">
            {items?.map((item, index) =>
              item ?
                <CarouselPropostaRataCard
                  className="embla__slide"
                  item={item}
                  key={item._id || index}
                />
              : null,
            )}
          </div>
        </div>
        <Dots>
          {scrollSnaps.map((_, index) => (
            <DotButton
              type="button"
              key={index}
              active={index === selectedIndex}
              onClick={() => scrollTo(index)}
              aria-label={`Vai alla proposta ${index + 1}`}
            />
          ))}
        </Dots>
        <ButtonContainer>
          <Link to="/preventivo">
            <RoundedButton className="white">
              RICHIEDI UN PREVENTIVO
            </RoundedButton>
          </Link>
        </ButtonContainer>
      </Container>
    </WrapDarkContainer>
  );
}
